module.exports = __webpack_public_path__ + "static/media/red-round-alert.298555b6.svg";